import { Component, OnDestroy, OnInit } from '@angular/core';
import { Customer } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ProfileActions from '@profile/profile.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromProfile from '@profile/profile.reducers';

import { TwoFAScreen } from '@shared/models/Profile';
import { LanguageService } from '@shared/services/language.service';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'app-profile-2fa',
  styleUrls: ['./profile-2fa.component.scss'],
  templateUrl: './profile-2fa.component.html',
  standalone: false
})
export class Profile2FAComponent implements OnInit, OnDestroy {
  currentScreen: TwoFAScreen;
  customer: Customer;
  enabled2FA = false;
  loading = false;
  openDisable2FA = false;
  token: string;
  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private languageService: LanguageService,
    private tokenService: TokenService
  ) {
    this.store.pipe(select(fromAppRoot.selectCustomer), takeUntil(this.onDestroy$)).subscribe((customer) => {
      this.customer = customer;
      this.enabled2FA = customer.otp_module === 'enabled';
    });
    this.store.pipe(select(fromProfile.select2FA), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.currentScreen = value.currentScreen;
      this.loading = value.loading;
    });
  }

  getArticle(): string {
    const articles = {
      en: 'https://help.inyova.ch/hc/en-us/articles/360017220140-How-do-I-enable-two-factor-authentication-',
      fr: 'https://help.inyova.ch/hc/fr/articles/360017220140-Comment-puis-je-activer-l-authentification-%C3%A0-deux-facteurs-',
      de: 'https://help.inyova.ch/hc/de/articles/360017220140-Wie-aktiviere-ich-die-Zwei-Faktor-Authentifizierung-'
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return articles[this.languageService.getRedirectLanguage()];
  }

  ngOnDestroy(): void {
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'main' }));
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    this.tokenService.validateToken().subscribe((response) => {
      if (response.status === 'success') {
        this.token = response.data.authentication_token;
      }
    });
  }

  validatePassword(pwd: string): void {
    this.store.dispatch(
      ProfileActions.validatePassword2FA({
        password: pwd,
        enabled2FA: this.enabled2FA,
        authToken: this.token
      })
    );
  }

  resendSMSCode(): void {
    this.store.dispatch(ProfileActions.send2FAAuthorizationCode({ authToken: this.token, redirect: 'verify' }));
  }

  validateCode(code: string): void {
    this.store.dispatch(ProfileActions.toggle2FAAuthorization({ code }));
  }

  toggle2FA(): void {
    if (this.enabled2FA && !this.openDisable2FA) {
      this.openDisable2FA = true;
      this.enabled2FA = false;
    } else {
      this.openDisable2FA = false;
      this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'password' }));
    }
  }
}
